import './globals.css';
import { Provider } from 'react-redux';
import { PropsWithChildren } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { store } from 'store';
import { interceptor } from 'api';
import { LoaderRedux } from 'components';

import theme from '../theme';

import { ToastProvider } from './toast-provider';

interceptor(store.dispatch);

export const Providers = ({ children }: PropsWithChildren) => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <LoaderRedux>
        <CssBaseline />
        <ToastProvider />
        {children}
      </LoaderRedux>
    </ThemeProvider>
  </Provider>
);
